import React from 'react';
import { connect } from 'react-redux';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';

import { SigningInSpinner } from '../authentication/components/loginSpace/SigningInSpinner';
import { AppState } from '../bootstrap/redux/state/AppState';
import { InitializationForm } from '../userSettings/components/initialization/InitializationForm';
import { RootAdminUiState } from './RootAdminUIState';

export interface RootAdminUiStateProps {
  readonly rootAdminUiState: RootAdminUiState;
}

export interface RootAdminUiOwnProps {}

export type RootAdminUiProps = RootAdminUiOwnProps & RootAdminUiStateProps;

/*
  This displays the non-default RootAdminUiStates.
  It will render null for the default state.
  tbApp.ts will handle displaying a ui-view for the default case.
*/
export class RootAdminUi extends React.Component<RootAdminUiProps> {
  public render() {
    if (this.props.rootAdminUiState === 'default') {
      return null;
    }

    return (
      <div className="tb-column-flex-parent tb-fill">
        <div className="tb-flex-fill">
          {this.stateUi()}
        </div>
      </div>
    );
  }

  public componentDidMount() {
    // Reset the title to just the server name.
    // fatal means we were unable to load messages so don't try to set a title
    if (this.props.rootAdminUiState !== 'fatal' && this.props.rootAdminUiState !== 'bootstrap') {
      BrowserTitleService.setTitleToServerName();
    }
  }

  private stateUi = () => {
    if (this.props.rootAdminUiState === 'untrusted') {
      return <Untrusted />;

    } else if (this.props.rootAdminUiState === 'init') {
      return <InitializationForm />;

    } else if (this.props.rootAdminUiState === 'interstitial') {
      return <SigningInSpinner />;

    } else if (this.props.rootAdminUiState === 'fatal') {
      return <span style={{marginLeft:20}}><h2>{'Fatal Error'}</h2></span>;
    }
  };
}

const mapStateToProps: MapStateToProps<RootAdminUiStateProps> = (state: AppState) => ({
  rootAdminUiState: state.rootAdminUiState,
});

export const ConnectedRootAdminUi: React.ComponentClass<RootAdminUiOwnProps> =
  connect(mapStateToProps)(RootAdminUi);

export const Untrusted = () => {
  return (
    <div className={'tb-error-box'} role={'alert'} aria-atomic={'true'}>
      <div className={'tb-error-box-message'} tb-test-id={'initialization-untrusted-error'}>
        {Messages.untrustedMachineOnUninitializedServer()}
      </div>
      <div className={'tb-error-box-message'} tb-test-id={'initialization-untrusted-error-details'}>
        {Messages.untrustedMachineOnUninitializedServerDetails()}
      </div>
    </div>
  );
};
